import { useState } from "react";
import { CaretRight, CaretDown } from "@phosphor-icons/react";

// Progressive-disclosure wrapper for deep technical sections -- same visual chrome as the
// plain SectionCard, but the body only renders once expanded. Pure presentation; never touches
// the data/values passed in as children.
export const CollapsibleSectionCard = ({ id, title, icon: Icon, children, testId, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section id={id} data-testid={testId} className="scroll-mt-24 rounded-lg border border-white/10 bg-eb-surface p-5">
      <button
        type="button"
        data-testid={`${testId}-toggle`}
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        className="flex w-full items-center justify-between gap-2 text-left"
      >
        <div className="flex items-center gap-2">
          {Icon && <Icon size={18} className="text-eb-accent" />}
          <h2 className="font-heading text-lg uppercase tracking-tight text-white">{title}</h2>
        </div>
        {open ? <CaretDown size={16} className="text-zinc-500" /> : <CaretRight size={16} className="text-zinc-500" />}
      </button>
      {open && <div className="mt-4">{children}</div>}
    </section>
  );
};
